/**
 * MINIMAL POPUP DISMISSAL ONLY
 * This version ONLY dismisses the popup without interfering with language switching, shopify will decide based on language settings
 */
(function() {
  'use strict';
  
  // Only set the dismissal flag, nothing else
  const THEME_LOCALSTORAGE_KEY = 'languagePopupDismissed';
  
  // Set the dismissal flag
  localStorage.setItem(THEME_LOCALSTORAGE_KEY, 'true');
  
  // Optional: Log current state for debugging
  console.log('Popup dismissal set. Current locale:', 
    typeof Shopify !== 'undefined' ? Shopify.locale : 'unknown'
  );
  
  // To safeguard API rate, no cookies are set or interfere with language switching
  // Let Shopify handle all language switching logic
})();